import React, { useState, useEffect } from "react";
import { Trash2 } from "lucide-react";
import Navbar from "./navbar";
import Footer from "./footer";
import AddOrEditNewsletterForm from "./AddOrEditNewsletterForm";
import { useNavigate } from "react-router-dom";
import "../index.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const NewsletterManager = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [filteredNewsletters, setFilteredNewsletters] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [message, setMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [deleteId, setDeleteId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    console.log(token);
    fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const sortedData = data.sort(
            (a, b) => new Date(b.publishedDate) - new Date(a.publishedDate),
          );
          setNewsletters(sortedData);
          setFilteredNewsletters(sortedData);
        } else {
          console.error("Unexpected API response format", data);
          setNewsletters([]);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setShowFormModal(true);
  };

  const handleEdit = (item) => {
    setEditData(item);
    setShowFormModal(true);
  };

  const handleSuccess = (isEdit) => {
    setPopupMessage(
      isEdit ? "Blog updated successfully!" : "Blog added successfully!",
    );
    setShowPopup(true);
    setShowFormModal(false);
    setEditData(null);
  };

  const handleClose = () => {
    setShowFormModal(false);
    setEditData(null);
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        const response = await fetch(
          `${BASE_URL}/newsletter/delete/${deleteId}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.ok) {
          setMessage("Blog deleted successfully!");
          setNewsletters(newsletters.filter((item) => item.id !== deleteId));
          setFilteredNewsletters(
            filteredNewsletters.filter((item) => item.id !== deleteId),
          );
        } else {
          setMessage("Failed to delete blog.");
        }
      } catch (error) {
        console.error("Error deleting blog:", error);
        setMessage("Error occurred while deleting.");
      }
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredNewsletters.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const pageNumbers = Array.from(
    { length: Math.ceil(filteredNewsletters.length / itemsPerPage) },
    (_, i) => i + 1,
  );

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div
            className="d-flex justify-content-between mb-3"
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4 className="fw-bold">Blog Manager</h4>
            <button className="btn btn-primary" onClick={handleAdd}>
              Create New Blog
            </button>
          </div>

          <div>
            {currentItems.length === 0 ? (
              <p>No data available.</p>
            ) : (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Text</th>
                    <th>Description</th>
                    <th>HTML Page Link</th>
                    <th>Background Image</th>
                    <th>Likes Count</th>
                    <th>Categories</th>
                    <th>Published Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.text}</td>
                      <td>{item.description}</td>
                      <td>{item.htmlPageLink}</td>
                      <td>{item.backgroundImage}</td>
                      <td>{item.likesCount}</td>
                      <td>{item.categories}</td>
                      <td>
                        {new Date(item.publishedDate).toLocaleDateString()}
                      </td>
                      <td>
                        <button
                          className="btn btn-secondary me-2"
                          onClick={() => handleEdit(item)}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <Trash2
                          size={20}
                          color="gray"
                          style={{ cursor: "pointer" }}
                          onClick={() => confirmDelete(item.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <nav className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {pageNumbers.map((number) => (
                <li key={number} className="page-item">
                  <button
                    className={`page-link ${number === currentPage ? "active" : ""}`}
                    onClick={() => paginate(number)}
                  >
                    {number}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === pageNumbers.length}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>

          {showFormModal && (
            <div className="modal" style={{ display: "block" }}>
              <div
                className="modal-dialog"
                style={{
                  width: "80%",
                  maxWidth: "580px",
                  height: "100vh",
                  margin: "auto",
                  marginTop: "50px",
                }}
              >
                <div
                  className="modal-content"
                  style={{ backgroundColor: "#e6e8ec" }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title fw-bold">
                      {editData ? "Edit Blog" : "Create New Blog"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <AddOrEditNewsletterForm
                      initialData={editData}
                      onSuccess={handleSuccess}
                      onError={() => console.error("Error occurred!")}
                      onClose={handleClose}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {showDeleteModal && (
            <div className="modal" style={{ display: "block" }}>
              <div className="modal-dialog" style={{ marginTop: "100px" }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Deletion</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowDeleteModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>Are you sure you want to delete this blog?</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-danger" onClick={handleDelete}>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showPopup && (
            <div className="modal" style={{ display: "block" }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "green" }}
                  >
                    <h5 className="modal-title">Success</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowPopup(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>{popupMessage}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowPopup(false);
                        window.location.reload();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsletterManager;
